// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class*=InfoTable__actionWrap] {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  min-width: 64px;
}
[class*=InfoTable__actionWrap] [class*=DotsDropdown__container] {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  margin-left: 8px;
}
.ant-dropdown-menu.DotsDropdown__container__ibptn, ul.ant-dropdown-menu[class*=DotsDropdown__container] {
  display: flex !important;
  flex-direction: column !important;
  flex-wrap: nowrap !important;
}`, "",{"version":3,"sources":["webpack://./src/shared/styles/fixes.scss"],"names":[],"mappings":"AAIE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAHJ;AAOE;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AALJ;AASE;EAEE,wBAAA;EACA,iCAAA;EACA,4BAAA;AAPJ","sourcesContent":["// Local fixes for third-party component styles\n\n:global {\n  // Fix InfoTable action wrap to properly display the dots button\n  [class*=\"InfoTable__actionWrap\"] {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex-shrink: 0;\n    min-width: 64px;\n  }\n\n  // Fix DotsDropdown button visibility\n  [class*=\"InfoTable__actionWrap\"] [class*=\"DotsDropdown__container\"] {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    margin-left: 8px;\n  }\n\n  // Fix DotsDropdown menu to display items vertically\n  .ant-dropdown-menu.DotsDropdown__container__ibptn,\n  ul.ant-dropdown-menu[class*=\"DotsDropdown__container\"] {\n    display: flex !important;\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
